module.exports = __webpack_public_path__ + "static/media/battery_30.b30f350a.svg";